// extracted by mini-css-extract-plugin
export default {"main":"NavBar_main__tAHRc","logo":"NavBar_logo__pSoy7","right":"NavBar_right__hizwU"};